import { useContext } from 'react';
import { ExportacaoEscritaFiscalContextData } from '../types/context';
import { ExportacaoEscritaFiscalContext } from '../context/ExportacaoEscritaFiscalContext';

export const useExpEscritaFiscal = (): ExportacaoEscritaFiscalContextData =>
  useContext(ExportacaoEscritaFiscalContext);
